<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">

    <span class="panel-title" *ngIf="!competitorId">  {{'competitor.createCompetitor' | translate}}</span>
    <span class="panel-title" *ngIf="competitorId">  {{'competitor.editCompetitor' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="container text-center" *ngIf="displayMode==1">
        <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
      </div>
      <form #f="ngForm" *ngIf="displayMode==2"
            novalidate (ngSubmit)="save(f)">
        <div class="row padding-sm-vr">
          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (competitorName.dirty || competitorName.touched || f.submitted)  && competitorName.valid, 'has-error' : (competitorName.dirty || competitorName.touched || f.submitted)  && competitorName.invalid}">
              <label class="control-label">{{'app.name' | translate}} </label>
              <input class="form-control" placeholder="{{'app.name' | translate}}" required
                     name="competitorName" #competitorName="ngModel"
                     [(ngModel)]="competitor.name" type="text">
              <div *ngIf="(competitorName.dirty || competitorName.touched || f.submitted)  && competitorName.errors?.required" class="jquery-validate-error help-block">
                {{'generalValidations.requiredField' | translate}}
              </div>
            </div>
          </div>

          <div class="col-sm-6" *ngIf="!visitsByItems">
            <div [ngClass]="{'has-success': (competitorBrand.dirty || competitorBrand.touched || f.submitted)  && competitorBrand.valid, 'has-error' : (competitorBrand.dirty || competitorBrand.touched || f.submitted)  && competitorBrand.invalid}">
              <label class="control-label">{{'Brands' | translate}} </label>
              <span class="ui-fluid">
                <p-dropdown [options]="itemBrands"
                            styleClass="wid100"
                            placeholder="{{'Brand' | translate}}"
                            emptyFilterMessage="{{'app.noItemsFound' |translate}}"
                            showClear="true" required
                            name="competitorBrand" #competitorBrand="ngModel"
                            [(ngModel)]="selectedItemBrand" baseZIndex="9999"
                            [filter]="true" optionLabel="name"></p-dropdown>
              </span>
              <div *ngIf="(competitorBrand.dirty || competitorBrand.touched || f.submitted)  && competitorBrand.errors?.required" class="jquery-validate-error help-block">
                {{'generalValidations.requiredField' | translate}}
              </div>
            </div>
          </div>

          <div class="col-sm-6" *ngIf="visitsByItems">
            <div [ngClass]="{'has-success': (competitorItem.dirty || competitorItem.touched || f.submitted)  && competitorItem.valid, 'has-error' : (competitorItem.dirty || competitorItem.touched || f.submitted)  && competitorItem.invalid}">
              <label class="control-label">{{'Items' | translate}} </label>
              <span class="ui-fluid">
                <p-dropdown [options]="items"
                            styleClass="wid100"
                            placeholder="{{'Items' | translate}}"
                            emptyFilterMessage="{{'app.noItemsFound' |translate}}"
                            showClear="true" required
                            name="competitorItem" #competitorItem="ngModel"
                            [(ngModel)]="selectedItem" baseZIndex="9999"
                            [filter]="true" optionLabel="name"></p-dropdown>
              </span>
              <div *ngIf="(competitorItem.dirty || competitorItem.touched || f.submitted)  && competitorItem.errors?.required" class="jquery-validate-error help-block">
                {{'generalValidations.requiredField' | translate}}
              </div>
            </div>
          </div>
        </div>

        <div class="panel-footer margin-left-20 margin-top-20 margin-left-37">
          <button class="btn  btn-cancel" type="button" (click)="back()">{{'app.cancel' | translate}}</button>&nbsp;
          <button class="btn  btn-save" type="submit" [disabled]="f.invalid">{{'app.save' | translate}}</button>

        </div>

      </form>
    </div>
  </div>
</div>

<div class="row col-sm-12 padding-sm-hr" *ngIf="displayMode==3">
  <div class="alert alert-danger alert-dark">
    <button type="button" class="close" data-dismiss="alert">×</button>
    {{'app.ServerError' |translate}}.
  </div>
</div>
